$(document).ready(function () {
    let option = {
        'animation': true,
        'autohide': true,
        'delay': 4000
    }
    $('.toast').toast(option).toast('show');

});
